import { Suspense, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

function wrapPromise(promise) {
  let status = 'pending';
  let result;
  let suspender = promise.then(
    (r) => {
      status = 'success';
      result = r;
    },
    (e) => {
      status = 'error';
      result = e;
    },
  );
  return {
    read: () => {
      if (status === 'pending') {
        throw suspender;
      } else if (status === 'error') {
        throw result;
      } else if (status === 'success') {
        return result;
      }
    },
  };
}

const promiseByName = {};
const fetchIcon = (name) => {
  if (promiseByName[name]) {
    return wrapPromise(promiseByName[name]);
  }

  const promise = fetch(`${window.routes.publicIcon}/${name}.svg`).then(
    (response) => {
      if (response.status !== 200) {
        throw new Error('Icône inconnue : ' + name);
      }
      return response.text();
    },
  );
  promiseByName[name] = promise;

  return wrapPromise(promise);
};

// On n'utilise pas Parcel pour récupérer l'icône pour laisser la possibilité au client de changer ses icônes par la suite
export const AsyncIcon = ({ resource, className }) => {
  const spanRef = useRef();
  const svgText = resource.read();

  /* eslint-disable react-hooks/exhaustive-deps */
  // on ne veut pas que le useEffect se relance, on ne lui donne donc pas de dépendences
  useEffect(() => {
    const parentNode = spanRef.current.parentNode;
    if (!parentNode) {
      // Cela veut dire que la modification a déjà été faite
      return;
    }

    // On utilise outerHTML pour ne plus avoir de span
    spanRef.current.outerHTML = svgText;
    parentNode.querySelector('svg').classList.add(className);
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  return <span ref={spanRef}></span>;
};
AsyncIcon.propTypes = {
  resource: PropTypes.object.isRequired,
  className: PropTypes.string,
};

const Icon = ({ name, className }) => (
  <Suspense fallback={<></>}>
    <AsyncIcon resource={fetchIcon(name)} className={className} />
  </Suspense>
);
Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Icon;
